import { render, staticRenderFns } from "./FixedOddBingoFlashboard.vue?vue&type=template&id=22df47fc&scoped=true&"
import script from "./FixedOddBingoFlashboard.vue?vue&type=script&lang=js&"
export * from "./FixedOddBingoFlashboard.vue?vue&type=script&lang=js&"
import style0 from "./FixedOddBingoFlashboard.vue?vue&type=style&index=0&id=22df47fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22df47fc",
  null
  
)

export default component.exports